module.exports = __webpack_public_path__ + "img/Godwin.60e56287.jpeg";